import React from 'react';
import PropTypes from 'prop-types';
import {CuvetteRackShortIcon, CuvetteRackLongIcon, CuvetteRackExtraShortIcon} from '../../Icons';
import {Image} from '@learningblocks/shared-components';
import {PROTOCOL_LAB_APPARATUS} from '@learningblocks/exp-constants/lib/Utilities';

export function CuvetteRack(props) {
  const getRackImage = () => {
    switch (props.type) {
      case PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_EXTRA_SHORT:
        return CuvetteRackExtraShortIcon;
      case PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_SHORT:
        return CuvetteRackShortIcon;
      case PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_LONG:
        return CuvetteRackLongIcon;
      default:
        return '';
    }
  };

  return (
    <Image
      className={props.className}
      src={getRackImage()}
      alt={`Cuvette Rack: ${props.type}`}
    />
  );
}

CuvetteRack.propTypes = {
  /**
   * ClassName for component
   */
  className: PropTypes.string,
  /**
   * Type of Cuvette Rack
   */
  type: PropTypes.oneOf([
    PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_LONG,
    PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_SHORT,
    PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_EXTRA_SHORT,
  ]),
};

CuvetteRack.defaultProps = {
  type: PROTOCOL_LAB_APPARATUS.CUVETTE_RACK_SHORT,
};
